<template>
  <div class="image_bg">
    <div class="form">
      <div class="brand_box_b" @click="goToPlanA">
        <!-- <div class="logo"> -->
          <!-- <div class="logo_image"></div> -->
        <!-- </div> -->
        <div class="brand_name">有朋相册</div>
        <div class="brand_dscp">您的专属家庭相册、朋友相册、团队相册<br>一个有温度、有归属感的共享相册</div>
      </div>
      <div class="login_box_b">
        <div class="btn_solid" @click="goToLogin">登录</div>
        <div class="btn_border" @click="goToSignup">注册</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HomeB',
  data: function () {
    return {
    }
  },
  methods: {
    goToSignup() {
      this.$router.push({ path: '/signup_b' })
    },
    goToLogin() {
      this.$router.push({ path: '/login_b' })
    },
    goToPlanA() {
      this.$router.push({ path: '/home' })
    }
  }
}
</script>

<style scoped lang="scss">
  

</style>
  